// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1hQcv","title":"Images45_title__10LLo","images":"Images45_images__3z93q"};